import { render } from "./doc.vue?vue&type=template&id=4b7deb7b&ts=true"
import script from "./doc.vue?vue&type=script&lang=ts"
export * from "./doc.vue?vue&type=script&lang=ts"

import "./doc.vue?vue&type=style&index=0&id=4b7deb7b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__